import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Modal, Row, Select } from "antd";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { adminCredentialsSchema } from "../../validattion";
const { Option } = Select;

const CreateAdminModal = (props) => {
  // Props
  const {
    visible,
    formMode,
    closeModal,
    one_admin,
    setDefaultAdmins,
    defaultAdmins,
  } = props;

  // Hooks states
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState("");
  const [error, setError] = useState(false);

  const checkMode = formMode === "CREATE_MODE";

  // Form
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      role: one_admin ? one_admin?.roleId : "",
    },
    resolver: yupResolver(adminCredentialsSchema),
  });

  // Close modal and empty fields
  const closeAdminModal = () => {
    reset({
      firstName: "",
      lastName: "",
      email: "",
      role: "",
    });
    closeModal();
  };

  const roles = [
    {
      name: "Support",
      id: "1",
    },
    {
      name: "Super",
      id: "2",
    },
    {
      name: "Control",
      id: "3",
    },
  ];

  // Async function
  const createProduct = async (data) => {
    setLoading(true);
    const { firstName, lastName, email, role } = data;
    if (formMode === "CREATE_MODE") {
      const createObj = {
        ...data,
        price,
      };
      // const res = await CreateOneAdmin(createObj);
      // if (res.success) {
      //   setLoading(false);
      //   toast.success("Product Created Successfully", {
      //     pauseOnHover: false,
      //   });
      //   requestAnimationFrame(() => {
      //     closeAdminModal();
      //     setLoading(false);
      //   });
      // } else if (!res.success && res.message === undefined) {
      //   setLoading(false);
      //   toast.error("Network Error", {
      //     pauseOnHover: true,
      //   });
      // } else {
      //   setLoading(false);
      //   toast.error(res.message, {
      //     pauseOnHover: true,
      //   });
      // }
      const findRoleName = roles?.find((el) => el?.id === role)?.name;
      const body = {
        firstName,
        lastName,
        email,
        roleId: role,
        roleName: findRoleName,
        id: defaultAdmins?.length + 1,
      };
      setDefaultAdmins([...defaultAdmins, body]);
      setLoading(false);
      closeAdminModal();
    } else if (formMode === "UPDATE_MODE") {
      const findRoleName = roles?.find((el) => el?.id === role)?.name;
      const updateObj = {
        firstName,
        lastName,
        email,
        roleId: role,
        roleName: findRoleName,
        id: one_admin?.id,
      };
      const filteredAdmins = defaultAdmins?.filter(
        (el) => el?.id !== one_admin?.id
      );
      setDefaultAdmins([...filteredAdmins, updateObj]);
      setLoading(false);
      closeAdminModal();
      // const res = await UpdateOneProduct(updateObj);
      // if (res.success) {
      //   setLoading(false);
      //   toast.success("Product Updated Successfully", {
      //     pauseOnHover: false,
      //   });
      //   requestAnimationFrame(() => {
      //     closeAdminModal();
      //     setLoading(false);
      //   });
      // } else if (!res.success && res.message === undefined) {
      //   setLoading(false);
      //   toast.error("Network Error", {
      //     pauseOnHover: true,
      //   });
      // } else {
      //   setLoading(false);
      //   toast.error(res.message, {
      //     pauseOnHover: true,
      //   });
      // }
    }
  };

  // Use effect to update fields
  useEffect(() => {
    if (one_admin) {
      setValue("firstName", one_admin?.firstName);
      setValue("lastName", one_admin?.lastName);
      setValue("email", one_admin?.email);
      setValue("role", one_admin?.roleId);
    }
  }, [one_admin]);

  const adminChildren = roles?.map((obj) => {
    return (
      <Option key={obj.id} value={obj.id}>
        {obj.name}
      </Option>
    );
  });
  return (
    <>
      <Modal
        visible={visible}
        title={
          <p style={{ fontWeight: "bold" }}>
            {checkMode ? "Create Admin" : `Update Admin`}
          </p>
        }
        footer={null}
        onCancel={closeAdminModal}
        maskClosable={false}
        width={"400px"}
      >
        <form onSubmit={handleSubmit(createProduct)} autoComplete="off">
          <div className="content">
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>First Name</label>
                  <input
                    name="firstName"
                    className="ant-input ant-input-lg"
                    placeholder="Type in First Name"
                    {...register("firstName")}
                  />

                  {errors.firstName && (
                    <span className="error">First name cannot be empty</span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Last Name</label>
                  <input
                    name="lastName"
                    className="ant-input ant-input-lg"
                    placeholder="Type in Last Name"
                    {...register("lastName")}
                  />

                  {errors.lastName && (
                    <span className="error">Last name cannot be empty</span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Email</label>
                  <input
                    name="email"
                    className="ant-input ant-input-lg"
                    placeholder="Type in Email"
                    {...register("email")}
                  />

                  {errors.email && (
                    <span className="error">Email cannot be empty</span>
                  )}
                </Col>
              </Row>
            </div>

            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Role</label>
                  <Controller
                    name="role"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Select
                        allowClear
                        name="role"
                        placeholder="Select a role"
                        style={{ width: "100%" }}
                        size="large"
                        value={value}
                        onChange={onChange}
                      >
                        {adminChildren}
                      </Select>
                    )}
                  />
                  {errors.role && (
                    <span className="error">
                      Admin Role is a required field
                    </span>
                  )}
                </Col>
              </Row>
            </div>
          </div>
          <Divider />
          <Row style={{ margin: "2rem 0" }}>
            <Col xs={24} style={{ textAlign: "right" }}>
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                style={{ marginRight: "10px" }}
              >
                {formMode === "CREATE_MODE" ? "Create" : "Update"} Admin
              </Button>
            </Col>
          </Row>
        </form>
      </Modal>
    </>
  );
};

export default CreateAdminModal;
